import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useTheme } from "./ThemeContext";
import { routesList } from "../Routes";

const ThemeRouteController = () => {
  const location = useLocation();
  const { enableTheme, disableTheme } = useTheme();

  useEffect(() => {
    const isProtected = routesList?.filter((r) => r.protected).some(path =>
      matchPath(path, location.pathname)
    );

    if (isProtected) {
      enableTheme();
    } else {
      disableTheme();
    }
  }, [location.pathname]);

  return null;
};

export default ThemeRouteController;
